import { useGetOverviewsForUrl } from './useGetOverviewsForUrl';

export function useGetFaviconUrl(url: string) {
	const overviews = useGetOverviewsForUrl(url);
	const reportGuid = overviews.length > 0 ? overviews[overviews.length - 1]['guid'] : null;
	const faviconUrl = reportGuid ? `https://d1r7943vfkqpts.cloudfront.net/${reportGuid}.png` : '';
	return faviconUrl;
}
